// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner-module--banner--tSUUD","title":"banner-module--title--2_rNs"};